import { useState } from 'react'
import { BaseContenutoConProgress, BaseTitolo, BaseScatola, BaseButtons, ICONE, BaseGridLayout } from '@lucan/base-ui'
import { ErroreSalvataggioTarga, GestioneTargheSlotGiornalieri, GestioneTargheStandard, isPermessoSloGiornalieri, RiassuntoTarghePermesso, useFetchTarghe, useModificaTarghe } from '@lucan/base-ui-jconnet'
import { OPERAZIONI } from 'configuration/ConfigurazioneApi'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import useInfoComando from 'hook/useInfoComando'
import { useRichiestaServerLogged } from 'hook/useRichiestaServerLogged'

export default function PassDettagliTarghe(props) {
  const { permesso, forzaFetchPermesso } = props

  const {
    targhe,
    setTarghe,
    dataRiferimento,
    setDataRiferimento,
    setForzaFetch,
    ScatolaMessaggi,
    inAttesaDelServer,
  } = useFetchTarghe({
    permesso,
    operazioneTargaLista: OPERAZIONI.PASS_GET_LISTA_TARGA,
    useRichiestaServer_Custom: useRichiestaServerLogged,
    trasformaRichiesta: ({ dataInizio, dataFine, ...rest }) => ({
      dataInizio: dataInizio?.getTime(),
      dataFine: dataFine?.getTime(),
      ...rest
    }),
    trasformaRisposta: ({ data }) => data,
  })

  return (
    <>
      {ScatolaMessaggi}

      <BaseContenutoConProgress inAttesa={inAttesaDelServer}>
        {targhe &&
          <FormPermessoDatiTarghe
            permessoUuid={permesso.uuid}
            permesso={permesso}
            targhe={targhe}
            setTarghe={setTarghe}
            dataRiferimento={dataRiferimento}
            setDataRiferimento={setDataRiferimento}
            forzaFetchTarghe={() => setForzaFetch(true)}
            forzaFetchPermesso={forzaFetchPermesso}
          />
        }
      </BaseContenutoConProgress>
    </>
  )
}



function FormPermessoDatiTarghe(props) {
  const {
    permessoUuid,
    permesso,
    targhe,
    setTarghe,
    dataRiferimento,
    setDataRiferimento,
    forzaFetchTarghe,
    forzaFetchPermesso,
  } = props
  const { targheTutte } = permesso.datiTarghe
  const { permessoBase } = permesso.datiBase
  const {
    opzioniPortale: {
      abilitaCreazioneTarga,
      abilitaModificaTarga,
      abilitaEliminazioneTarga,
      numGiorniIndietroBlocco,
    } = {}
  } = permessoBase
  const readOnly = targheTutte || !(abilitaCreazioneTarga || abilitaModificaTarga || abilitaEliminazioneTarga)

  const [modificaTargheStandardAttiva, setModificaTargheStandardAttiva] = useState(false)

  const {
    inAttesaCreazione,
    inAttesaModifica,
    idTargaInAttesaModifica,
    inAttesaEliminazione,
    idTargaInAttesaEliminazione,
    erroreSalvataggio,
    ScatolaMessaggi,
    aggiungiTarga,
    modificaTarga,
    eliminaTarga,
  } = useModificaTarghe({
    targhe,
    setTarghe,
    permessoUuid,
    readOnly,
    operazioneTargaUpdate: OPERAZIONI.PASS_UPDATE_TARGA,
    useRichiestaServer_Custom: useRichiestaServerLogged,
    trasformaRichiesta: ({ targa, ...rest }) => ({
      targa: {
        ...targa,
        id: targa.id ?? 0,
        permessoUuid,
        dataInizio: targa.dataInizio?.getTime(),
        dataFine: targa.dataFine?.getTime(),
      },
      ...rest
    }),
    trasformaRisposta: ({ data }) => data,
    trasformaRispostaOk: (_, data) => data.esito,
    trasformaRispostaErrore: (_, data) => data.esito ? null : data,
  })

  const { infoComando } = useInfoComando()

  const {
    ScatolaMessaggi: ScatolaMessaggiModificaSlot,
    inviaOperazione,
    inAttesaDelServer: inAttesaModificaSlot
  } = useRichiestaServerLogged()
  
  async function modificaSlot(slot) {
    const { id, label } = slot
    const { ok, data } = await inviaOperazione(OPERAZIONI.PASS_UPDATE_SLOT, {
      permessoUuid,
      slotId: id,
      slotLabel: label,
    })
    if (ok && data.esito) forzaFetchPermesso()
  }

  return (
    <BaseScatola>
      {ScatolaMessaggi}
      {ScatolaMessaggiModificaSlot}

      <ErroreSalvataggioTarga
        erroreSalvataggio={erroreSalvataggio}
        forzaFetchTarghe={forzaFetchTarghe}
      />

      {isPermessoSloGiornalieri(permesso) && permesso.datiCategoriaSlotGiornalieri ? (
        <GestioneTargheSlotGiornalieri
          permesso={permesso}
          targhe={targhe}
          dataRiferimento={dataRiferimento}
          setDataRiferimento={setDataRiferimento}
          {...(abilitaCreazioneTarga && { aggiungiTarga })}
          {...(abilitaModificaTarga && { modificaTarga })}
          {...(abilitaEliminazioneTarga && { eliminaTarga })}
          inAttesaCreazione={inAttesaCreazione}
          inAttesaModifica={inAttesaModifica}
          inAttesaEliminazione={inAttesaEliminazione}
          readOnly={readOnly}
          chiaveElencoMotivazioniModificaTarga={ELENCHI.PASS_MOTIVAZIONI_MODIFICA_TARGA}
          numGiorniIndietroBlocco={numGiorniIndietroBlocco}
          onModificaSlot={modificaSlot}
          inAttesaModificaSlot={inAttesaModificaSlot}
          abilitaStampaDettaglioTarga
          nomeComando={infoComando?.nome}
        />
      ) : (
        <>
          <BaseGridLayout alignCenter sx={{ mb: 2 }}>
            <BaseTitolo>Targhe</BaseTitolo>
            <BaseButtons.Custom
              testo={modificaTargheStandardAttiva ? 'Termina modifica' : 'Modifica'}
              iconaInizio={modificaTargheStandardAttiva ? ICONE.CHIUDI : ICONE.MODIFICA}
              color='info'
              onClick={() => setModificaTargheStandardAttiva(modifica => !modifica)}
              hidden={readOnly}
            />
          </BaseGridLayout>

          {modificaTargheStandardAttiva ? (
            <GestioneTargheStandard
              targhe={targhe}
              {...(abilitaCreazioneTarga && { aggiungiTarga })}
              {...(abilitaModificaTarga && { modificaTarga })}
              {...(abilitaEliminazioneTarga && { eliminaTarga })}
              inAttesaCreazione={inAttesaCreazione}
              inAttesaModifica={inAttesaModifica}
              idTargaInAttesaModifica={idTargaInAttesaModifica}
              inAttesaEliminazione={inAttesaEliminazione}
              idTargaInAttesaEliminazione={idTargaInAttesaEliminazione}
              usaBottoneSubmit
              elencoTipiVeicolo={ELENCHI.TIPI_VEICOLO}
            />
          ) : (
            <RiassuntoTarghePermesso targhe={targhe} targheTutte={targheTutte} />
          )}
        </>
      )}
    </BaseScatola>
  )
}